import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import type {WorkoutId} from '../../domain/workout-id.value-object';

export class WorkoutIdValidator implements Validator<WorkoutId> {
  readonly standardSchema = z.templateLiteral(['wko', '_', z.string().min(1)]);

  validate(value: unknown): Result<WorkoutId, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(
        new ValidationError(parsed.error.issues[0]?.message ?? 'Invalid workout id.'),
      );
    }
    return ok(parsed.data);
  }
}
